import {string_to_slug} from './Functions.js';   
class ProductCatalogue {
  /**
   * @link ./ProductTabs
   */
  constructor() {
    this.container = document.querySelector('.product__tabcontent');
    this.pagecontent = document.querySelector('.product');
    this.levels = {
      family: null,
      group: null,
      product: null
    }
    this.breadcrumbs = [];
    this.urlchange = new Event('urlchange');
    this.country = document.body.dataset.country;

    this.events();
    document.dispatchEvent(this.urlchange);
  }
  /**
   * register event handlers
   */
  events() {
    // Prevent multiple event assignments
    if(!this.container.clickEvent) {
      this.container.addEventListener('click', this.routing.bind(this));
      this.container.clickEvent = true;
    }
    // Prevent multiple event assignments
    if(!document.urlchangeEvent) {
      document.addEventListener('urlchange', this.changePage.bind(this));
      document.urlchangeEvent = true;
    }
    window.onpopstate = e => {
      document.dispatchEvent(this.urlchange);
    }
  }

  replaceTitle() {

    setTimeout(() => {
      var currentUrl = window.location.pathname;
      // Extract the parts of the URL path
      var pathParts = currentUrl.split('/').filter(Boolean);
  
      // Get the last part excluding the initial part
      var lastPathSegment = pathParts.length > 1 ? pathParts.slice(1).pop() : '';
  
      // Remove dashes and update the banner text
      var formattedText = lastPathSegment.replace(/-/g, ' ');
      document.querySelector('.banner .wrapper h1').innerText = formattedText;

      if (document.querySelector('.dnadesign__elemental__models__elementcontent')) {
        if (document.querySelector('.dnadesign__elemental__models__elementcontent')) {
          // Remove the selected element from the DOM
          document.querySelector('.dnadesign__elemental__models__elementcontent').parentNode.removeChild(document.querySelector('.dnadesign__elemental__models__elementcontent'));
          
          //document.querySelector('.products-block').parentNode.removeChild(document.querySelector('.products-block'));
          //document.querySelector('.block-multibox').parentNode.removeChild(document.querySelector('.block-multibox'));

          //document.body.classList.add('product-page');
        }
      }

      if (!document.body.classList.contains('product-sub')) {
        // Add class "product-sub" to the body
        document.body.classList.add('product-sub');
      }
    }, 1000);
  }

  /**
   * Routing for click events on catalogue & breadcrumb buttons
   * Works by setting levels object to appropriate values, then calling buildUrl()
   * @param {Event} e 
   */
  routing(e) {
    const el = e.target;
    let route = el.dataset.route;
    let active = false;
    
    if(el.classList.contains('categories__categories--category') || el.classList.contains('breadcrumbs__family')) {
      this.levels.family = el.dataset.route;
      this.levels.group = null;
      this.levels.product = null;
      this.replaceTitle();
      //location.href = '/products/' + el.dataset.route;
      active = true;
    } else if(el.classList.contains('categories__groups--group') || el.classList.contains('breadcrumbs__group')) {
      this.levels.group = el.dataset.route;
      this.levels.product = null;
      active = true;
      this.replaceTitle();
      //location.href = '/products/' + this.levels.family + '/' + this.levels.group;
    } else if(el.closest('.categories__products--product')) {
      route = el.closest('.categories__products--product');
      this.levels.product = route.dataset.route;
      active = true;

      //location.href = '/products/' + this.levels.family + '/' + this.levels.group + '/' + this.levels.product;
      this.replaceTitle();
    } else if(el.classList.contains('breadcrumbs__catalogue')) {

      //location.href = '/products/';
      
      this.levels.family = null;
      this.levels.group = null;
      this.levels.product = null;
      active = true;

    } else if (el.classList.contains('product__tabcontent--back')) {
      // Go to next level up - chop the end off the url at '/'

      console.log('back');

      const path = location.pathname;
      const arr = path.split('/');
      // Deal with trailing slashes
      if(!arr[arr.length - 1]) {
        arr.length = arr.length - 1;
      }
      // Go to correct level - N.B. Group & Family both go back to main product page
      switch(arr.length) {
        case 3:
        case 4:
          location.href = arr[1];
        break;
        case 5:
          location.href = `${arr[1]}/${arr[2]}/${arr[3]}`;
        break;
        default: 
          location.href = '/products';

      }
    } else if (el.parentElement.classList.contains('product__variant--dropdown')) {
      const allDropdowns = document.querySelectorAll('.product__variant--dropdown--container');
      allDropdowns.forEach(dd => {
        el.parentElement === dd.parentElement ? dd.classList.toggle("show-details") : dd.classList.remove("show-details");
      });
    }
    if(active) {
      history.pushState('', 'Routing', this.buildUrl());
      document.dispatchEvent(this.urlchange);
    }
  }

  /**
   * Get levels from URL
   * Split into levels object
   * Call appropriate ajax function to retrieve data
   */
  changePage(e) {
    const patharray = document.location.pathname.split('/');
    this.levels.family = patharray[2] || null;
    this.levels.group = patharray[3] || null;
    this.levels.product = patharray[4] || null;

    if (document.body.classList.contains('product-page')) {
      document.body.classList.remove('product-page');
    }

    if(this.levels.product !== null) {
      this.getProduct();

      document.body.classList.add('product-page');
    } else if(this.levels.group !== null) {
      this.getProductCategory();
    } else if(this.levels.family !== null) {
      this.getProductCategory();
    } else {
      this.loadCategories(null);
    }
  }

  /**
   * Build URL from levels object
   * @returns url string
   */
  buildUrl() {
    let url = '/products';
    if(!this.levels.family) return url;
    url += "/" + this.levels.family;
    if(!this.levels.group) return url;
    url += "/" + this.levels.group;
    if(!this.levels.product) return url;
    url += "/" + this.levels.product;
    return url;
  }

  /**
   * build breadcrumb trail from breadcrumbs object
   * @returns HTMLString
   */
  buildBreadcrumbs() {
    let trail = `<span class="breadcrumbs__catalogue">Product catalogue</span>`;
    if(!this.breadcrumbs[0]) return trail;
    trail = `${trail} <span class='breadcrumbs__family' data-route='${this.levels.family}'> ${this.breadcrumbs[0]} </span>`
    if(!this.breadcrumbs[1]) return trail;
    trail = `${trail} <span class='breadcrumbs__group' data-route='${this.levels.group}'> ${this.breadcrumbs[1]} </span>`
    if(!this.breadcrumbs[2]) return trail;
    trail = `${trail} <span class='breadcrumbs__product' data-route='${this.levels.product}'> ${this.breadcrumbs[2]} </span>`
    return trail;
  }

  /**
   * Get breadcrumb HTML from @link{buildBreadcrumbs()}
   * Display on page
   */
  displayBreadcrumbs() {
    const breadcrumbs = document.querySelector('.product__tabcontent--breadcrumbs');
    if (breadcrumbs !== null) {
      breadcrumbs.innerHTML = this.buildBreadcrumbs();
    }
  }

  /**
   * Ajax function
   * Load categories (families)
   * Top level products page
   */
  loadCategories() {   
    document.body.classList.add('loading-page');

    const url = '/productapi/catlist/' + this.country;
    fetch(url,{
      method: 'GET',
      headers: {
        'Content-Type':'text/html',
        'x-requested-with': 'XMLHttpRequest'
      }
    })
    .then(response => response.text())
    .then(data => {
      this.container.innerHTML = data;
      this.breadcrumbs = [];
      this.displayBreadcrumbs();
      document.body.classList.remove('loading-page');
    })
  }

  /**
   * Ajax function to load groups within a family
   * Second level page
   */
  getProductCategory() {
    document.body.classList.add('loading-page');
    const url = `/productapi/category/${this.country}/${this.levels.family}`;
    fetch(url,{
      method: 'GET',
      headers: {
        'Content-Type':'text/html',
        'x-requested-with': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())  
    .then(data => {
      this.container.innerHTML = data.template;
      if(this.levels.group === null) {
        this.pagecontent.scrollIntoView({
          block: 'start',
          inline: 'nearest',
          behavior: 'smooth'
        });
      }
      this.breadcrumbs = data.breadcrumbs;
      this.displayBreadcrumbs();
      if(this.levels.group) {
        this.getProductGroup();
      } else {
        document.body.classList.remove('loading-page');
      }
    })
  }

  /**
   * Ajax function to load products within a group
   * Third level page
  */
  getProductGroup() {
    const url = `/productapi/group/${this.country}/${this.levels.group}/category/${this.levels.family}`;
    fetch(url,{
      method: 'GET',
      headers: {
        'Content-Type':'application/json',
        'x-requested-with': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(data => {
      const productlist = document.querySelector('.categories__products');
      const productTabContent = document.querySelector('.product__tabcontent');
      const groups = document.querySelectorAll('.categories__groups--group');
      productlist.innerHTML = data.template;
      productTabContent.scrollIntoView({
        block: 'start',
        inline: 'nearest',
        behavior: 'smooth'
      });
      groups.forEach(grp => {
        grp.classList.remove('categories__groups--selected');
        if(grp.dataset.route == this.levels.group) {
          grp.classList.add('categories__groups--selected');
        }
      });
      this.breadcrumbs = data.breadcrumbs;
      this.displayBreadcrumbs();

      document.body.classList.remove('loading-page');
    })
  }

  /**
   * Ajax function to load product page
   */
  getProduct() {
    document.body.classList.add('loading-page');

    const url = `productapi/product/${this.country}/${this.levels.product}`;
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type':'application/json',
        'x-requested-with': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(data => {
      this.container.innerHTML = data.template;
      this.pagecontent.scrollIntoView({
        block: 'start',
        inline: 'nearest',
        behavior: 'smooth'
      });
      this.breadcrumbs = data.breadcrumbs;
      this.displayBreadcrumbs();
      document.body.classList.remove('loading-page');
    })
  }
}

export default ProductCatalogue;